// 9fbef606107a605d69c0edbcd8029e5d
import { defaultMemoize } from 'reselect';
import logger from '@tcp/core/src/utils/loggerInstance';

const getIndex = (data) => {
  return data && data.some((category) => !!(category && category.url)) ? data.length : 0;
};

export const extractCategory = (category = '') => {
  // Extracting category id or path from the URL
  try {
    let categoryId;
    if (Number.isInteger(category)) {
      categoryId = category;
    } else if (category && category.lastIndexOf('/') === category.length - 1) {
      categoryId = category && category.split('/');
      categoryId = categoryId.length > 1 ? categoryId[categoryId.length - 2] : categoryId[0];
    } else {
      categoryId = category && category.split('/').pop();
    }
    return categoryId;
  } catch (err) {
    logger.error({
      error: err,
      extraData: {
        component: 'ProductListing Util - extractCategory',
        categoryRecieved: category,
      },
    });
  }
  return category;
};

const extractCategoryFilters = (navArray) => {
  const categoryFilterArray = navArray.map((arrayItem) => {
    const overrideCategoryName = arrayItem.categoryContent?.mainCategory?.set?.filter(
      (setEntry) => setEntry.key === 'categoryName' && setEntry.val
    )[0]?.val;
    if (!arrayItem.categoryContent?.displayToCustomer) {
      return false;
    }
    if (
      arrayItem.categoryContent &&
      arrayItem.categoryContent.mainCategory &&
      arrayItem.categoryContent.mainCategory.categoryFilterImage &&
      arrayItem.categoryContent.mainCategory.categoryFilterImage[0]
    ) {
      return {
        ...arrayItem.categoryContent.mainCategory.categoryFilterImage[0],
        linkUrl: arrayItem.url,
        linkAspath: arrayItem.asPath,
        filterTitle: overrideCategoryName || arrayItem.categoryContent.name,
      };
    }
    return {
      linkUrl: arrayItem.url,
      linkAspath: arrayItem.asPath,
      filterTitle: overrideCategoryName || arrayItem.categoryContent.name,
    };
  });

  return categoryFilterArray.filter((catItem) => !!catItem);
};

const hasSubCategories = (navObj, subCategoryArr) => {
  return navObj && navObj.subCategories && !navObj.subCategories.length && subCategoryArr.length;
};

const getNewCatArr = (navObj, subCategoryArr) => {
  let newCatArr = [];
  if (hasSubCategories(navObj, subCategoryArr)) {
    for (let groupCount = 0; groupCount < subCategoryArr.length; groupCount += 1) {
      newCatArr = newCatArr.concat(navObj.subCategories[subCategoryArr[groupCount]].items);
    }
  } else if (navObj.subCategories) {
    newCatArr = newCatArr.concat(navObj.subCategories);
  }
  return newCatArr;
};

const getSubcatArrInitial = (navObj) =>
  (navObj.subCategories && Object.keys(navObj.subCategories)) || [];
const getNavUrl = (navObj) =>
  // no need change navigation object url
  extractCategory(navObj.url && navObj.url.replace('/c?cid=', ''));

const isUrlMatching = (navObj, navUrl, categoryId) => {
  return (
    (navObj.categoryContent && navObj.categoryContent.categoryId === categoryId) ||
    (navUrl && navUrl.toLowerCase()) === (categoryId && categoryId.toLowerCase())
  );
};

const compareSetVal = (navObj, setKey, expectedVal) => {
  return (
    navObj?.categoryContent?.mainCategory?.set?.filter(
      (setEntry) => setEntry.key === setKey && setEntry.val
    )[0]?.val === expectedVal
  );
};

const extractSetVal = (navObj, setKey) => {
  const setItem =
    navObj?.categoryContent?.mainCategory?.set?.filter((item) => item.key === setKey) || [];
  return setItem && setItem[0] && setItem[0].val;
};

const getShopAllImageDetails = (navObj) =>
  (navObj.categoryContent?.mainCategory?.categoryFilterImage &&
    navObj.categoryContent.mainCategory.categoryFilterImage.length &&
    navObj.categoryContent.mainCategory.categoryFilterImage[0]) ||
  {};

const getShopAllArray = (
  categoryFilters,
  carouselShowShopAll,
  navObj,
  shopAllLabel,
  shopAllDisplayLocation
) => {
  if (categoryFilters && carouselShowShopAll) {
    const imageDetails = getShopAllImageDetails(navObj);
    const parentCatName = navObj?.categoryContent?.name || '';
    const shopAllArray = [
      {
        linkAspath: navObj?.categoryContent?.asPath,
        linkUrl: navObj?.categoryContent?.url,
        filterTitle: shopAllLabel || '',
        categoryId: navObj?.categoryContent?.catgroupId,
        title: `${parentCatName} > ${shopAllLabel || ''}`,
        alt: `${parentCatName} > ${shopAllLabel || ''}`,
        asPath: navObj?.categoryContent?.asPath,
        ...imageDetails,
      },
    ];
    return shopAllDisplayLocation === 'last'
      ? [...categoryFilters, ...shopAllArray]
      : [...shopAllArray, ...categoryFilters];
  }
  return categoryFilters;
};

const checkIfL2AndShouldShowSiblings = (categoryFilters, shouldShowSiblings) =>
  categoryFilters && shouldShowSiblings;

const isNewCatArrHasItem = (newCatArr) => newCatArr && newCatArr.length;

// eslint-disable-next-line sonarjs/cognitive-complexity
export const findCategoryFilter = (data, category, shopAllLabel) => {
  const index = getIndex(data);
  let iterator = 0;
  let navTreeStructureArray = [];
  const categoryId = extractCategory(category);

  while (iterator < index) {
    const navObj = data[iterator];
    const subCategoryArr = getSubcatArrInitial(navObj);
    const newCatArr = getNewCatArr(navObj, subCategoryArr);

    const navUrl = getNavUrl(navObj);

    if (isUrlMatching(navObj, navUrl, categoryId)) {
      // If the leaf node has categoryFilters object, it means it is an L2
      // In case of L2, we need to consider the configuration to show siblings or children
      // set.showSibling = "true" in case we need to show siblings
      let carouselData;
      const categoryFilters = navObj?.categoryFilters;
      const shouldShowSiblings = compareSetVal(navObj, 'showSibling', 'true');
      const shouldHideCarousel = compareSetVal(navObj, 'hideCarousel', 'true');
      const carouselTitle = extractSetVal(navObj, 'shopByCategory');
      if (shouldHideCarousel) {
        carouselData = [];
      }
      // If L2(=categoryFilters is defined) and should show siblings
      else if (checkIfL2AndShouldShowSiblings(categoryFilters, shouldShowSiblings)) {
        carouselData = extractCategoryFilters(data);
      }
      // if L2(=categoryFilters is defined) and should not show siblings, ie, show children
      // if L3, we do not have carouselData info at this level. Look for a level up = carouselData would be undefined.
      else {
        carouselData = categoryFilters;
      }
      navTreeStructureArray.push({
        set: navObj?.categoryContent?.mainCategory?.set,
        carouselData,
        carouselTitle,
      });
    } else if (isNewCatArrHasItem(newCatArr)) {
      navTreeStructureArray = findCategoryFilter(newCatArr, category, shopAllLabel);
      if (navTreeStructureArray.length) {
        const categoryFilters = navObj?.categoryFilters;
        const carouselTitle = extractSetVal(navObj, 'shopByCategory');

        const carouselShowShopAll = compareSetVal(navObj, 'shopAll', 'true');
        const shopAllDisplayLocation = extractSetVal(navObj, 'displayLocation');
        const shouldHideCarousel = compareSetVal(navObj, 'hideCarousel', 'true');
        // This is not the leaf node.
        // It is precisely the L2 if categoryFilters is defined.
        // If show children, then use the categoryFilters object as is.
        // if show siblings, still we need to use categoryFilters as this is for L3.
        // Also, check the ShopAll configuration and append the Shop ALL in the category Filter list.
        let carouselData = getShopAllArray(
          categoryFilters,
          carouselShowShopAll,
          navObj,
          shopAllLabel,
          shopAllDisplayLocation
        );
        if (shouldHideCarousel) {
          carouselData = [];
        }
        navTreeStructureArray.push({
          set: navObj?.categoryContent?.mainCategory?.set,
          carouselData,
          carouselTitle,
        });
      }
    }
    if (navTreeStructureArray.length) {
      break;
    } else {
      iterator += 1;
    }
  }
  return navTreeStructureArray;
};

const dataFormattor = (list, parentCatName, catLevel, l2name) => {
  if (catLevel === 1) {
    return list
      ?.filter((sib) => sib?.categoryContent?.displayToCustomer === true)
      ?.map((sibling) => {
        const filterTitle = sibling?.categoryContent?.name;
        return {
          categoryId: sibling?.categoryContent?.catgroupId,
          title: `${parentCatName} > ${filterTitle}`,
          alt: `${parentCatName} > ${filterTitle}`,
          filterTitle,
          linkAspath: sibling.asPath,
          asPath: sibling.asPath,
          linkUrl: sibling.url,
          url: sibling?.categoryContent?.mainCategory?.categoryFilterImage?.[0]?.url || '',
        };
      });
  }
  return list
    ?.filter((sib) => sib?.categoryContent?.displayToCustomer === true)
    ?.map((sibling) => {
      const filterTitle = sibling?.categoryContent?.name;
      return {
        categoryId: sibling?.categoryContent?.catgroupId,
        title: `${parentCatName} > ${l2name} > ${filterTitle}`,
        alt: `${parentCatName} > ${l2name} > ${filterTitle}`,
        filterTitle,
        linkAspath: sibling.asPath,
        asPath: sibling.asPath,
        linkUrl: sibling.url,
        url: sibling?.categoryContent?.mainCategory?.categoryFilterImage?.[0]?.url || '',
      };
    });
};

const getL2CaraoselData = (catObj, catId, catLevel, shopAllLabel) => {
  const parentCatName = catObj?.categoryContent?.name || '';
  let currentL2obj = {};
  const subCategories = catObj?.subCategories;
  let groupIdentifierName = '';
  let shouldShowSiblings;

  const groupKeys = Object.keys(catObj?.subCategories || {}) || [];
  groupKeys.forEach((key) => {
    subCategories[key]?.items?.forEach((item) => {
      if (item?.categoryContent?.catgroupId === catId) {
        currentL2obj = { ...item };
        groupIdentifierName = key;
      }
    });
    shouldShowSiblings = compareSetVal(currentL2obj, 'showSibling', 'true');
  });
  if (!currentL2obj?.categoryContent?.mainCategory) {
    return [];
  }
  const carouselShowShopAll = compareSetVal(currentL2obj, 'shopAll', 'true');
  const shopAllDisplayLocation = extractSetVal(currentL2obj, 'displayLocation');
  const l2name = currentL2obj?.categoryContent?.name;
  if (shouldShowSiblings && catLevel !== 3) {
    const siblings = subCategories[groupIdentifierName]?.items;
    if (siblings?.length > 0) {
      return getShopAllArray(
        dataFormattor(siblings, parentCatName, catLevel, l2name),
        carouselShowShopAll,
        catObj,
        shopAllLabel,
        shopAllDisplayLocation
      );
    }
  } else {
    const l3children = currentL2obj?.subCategories;
    if (l3children?.length > 0) {
      return getShopAllArray(
        dataFormattor(l3children, parentCatName, catLevel, l2name),
        carouselShowShopAll,
        catObj,
        shopAllLabel,
        shopAllDisplayLocation
      );
    }
  }
  return [];
};

const getL2DataForL1 = (catObj, shopAllLabel, catLevel) => {
  const parentCatName = catObj?.categoryContent?.name || '';
  if (!catObj?.categoryContent?.mainCategory) {
    return [];
  }

  let l2List = [];
  Object.values(catObj?.subCategories || {})
    .filter((groupItem) => groupItem.hasSubCategory)
    .sort((a, b) => {
      return parseInt(a.order, 10) - parseInt(b.order, 10);
    })
    .forEach((group) => {
      l2List = [...l2List, ...(group?.items || [])];
    });

  const carouselData = dataFormattor(l2List, parentCatName, catLevel);
  const carouselShowShopAll = compareSetVal(catObj, 'shopAll', 'true');
  const shopAllDisplayLocation = extractSetVal(catObj, 'displayLocation');
  return getShopAllArray(
    carouselData,
    carouselShowShopAll,
    catObj,
    shopAllLabel,
    shopAllDisplayLocation
  );
};

const findL1CategoryObject = defaultMemoize((navObj, catId) => {
  return navObj.find((nav) => nav.categoryId === catId);
});

export const findCategoryFilterData = defaultMemoize(
  (navigationData, currentNavIds, shopAllLabel) => {
    const l1CategoryObj = findL1CategoryObject(navigationData, currentNavIds[0]);
    const carouselTitle = extractSetVal(l1CategoryObj, 'shopByCategory');
    const catLevel = currentNavIds?.length;
    let carouselData = {};
    if (catLevel === 1) {
      carouselData = getL2DataForL1(l1CategoryObj, shopAllLabel, catLevel);
    } else if (catLevel === 2 || catLevel === 3) {
      carouselData = getL2CaraoselData(
        { ...l1CategoryObj },
        currentNavIds[1],
        catLevel,
        shopAllLabel
      );
    }
    return [{ carouselData, carouselTitle }];
  }
);

/**
 * checks L1 for certain categories as per requirement
 * @param {*} L1
 * @returns modified L1
 */
export const checkForCertainL1s = (L1) => {
  const L1maps = {
    girl: 'g',
    boy: 'b',
    toddlergirl: 'tg',
    toddlerboy: 'tb',
    babyboy: 'bb',
    babygirl: 'bg',
  };

  if (L1maps[L1?.replace(/ /g, '')]) {
    return L1maps[L1?.replace(/ /g, '')];
  }
  return L1;
};

export const breadCrumbStr = (breadCrumbs) => {
  let breadcrumbStr = '';
  if (breadCrumbs?.length > 1) {
    const breadcrumbCopy = [...breadCrumbs];
    breadcrumbCopy?.shift();
    const L1 = `_${checkForCertainL1s(breadcrumbCopy[0]?.displayName?.toLowerCase())}`;
    const L2 = `_${breadcrumbCopy[1]?.displayName || 'na'}`?.toLowerCase();
    const L3 = `_${breadcrumbCopy[2]?.displayName || 'na'}`?.toLowerCase();
    breadcrumbStr = `${L1}${L2}${L3}`;
  }
  return breadcrumbStr;
};

export const hasSbcContentChanged = (prevBreadCurmbStr, nextBreadCurmbStr) => {
  if (prevBreadCurmbStr !== undefined) {
    return prevBreadCurmbStr !== nextBreadCurmbStr;
  }
  return false;
};
export const getCarouselDataString = ({ carouselData = [] } = {}) => {
  let str = '';
  try {
    if (carouselData?.length > 0) {
      str = carouselData.map((data) => data.categoryId).join('|');
    }
  } catch (e) {
    return '';
  }

  return str;
};
